module.exports = "pegasus_template/assets/classic-linkedin.png";